import { useState, useEffect } from "react";
import { getAllAnchors } from "../services/anchorService";
import { fetchWATemplates } from "../services/watemplateService";
import { fetchSubscriptions } from "../services/subscriptionService";
import { createSubscriptionTemplate } from "../services/subTemplateService";
import { useNavigate } from "react-router-dom";



const CreateSubTemplate = ({ onBack }) => {
  const [formData, setFormData] = useState({
    day: "",
    time: "",
    anchor: "",
    subscription: "",
    watemplate: "",
  });

  const [anchors, setAnchors] = useState([]);
  const [waTemplates, setWATemplates] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();


  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [anchorList, templateList, subscriptionList] = await Promise.all([
          getAllAnchors(),
          fetchWATemplates(),
          fetchSubscriptions(),
        ]);
        setAnchors(anchorList);
        setWATemplates(templateList);
        setSubscriptions(subscriptionList);
      } catch (error) {
        setErrorMsg("Failed to load anchors, templates, or subscriptions.");
      }
    };

    fetchInitialData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSuccessMsg("");
    setErrorMsg("");

    // Validation
    if (formData.day === "" || isNaN(formData.day) || Number(formData.day) < 0) {
      setErrorMsg("Day is required and must be 0 or greater.");
      return;
    }
    if (!formData.time) {
      setErrorMsg("Time is required.");
      return;
    }
    if (!formData.anchor) {
      setErrorMsg("Anchor selection is required.");
      return;
    }
    if (!formData.watemplate) {
      setErrorMsg("Template selection is required.");
      return;
    }
    if (!formData.subscription) {
      setErrorMsg("Subscription selection is required.");
      return;
    }

    setLoading(true);
    try {
      await createSubscriptionTemplate({
        day: Number(formData.day),
        time: formData.time,
        anchor: formData.anchor,
        subscription: formData.subscription,
        watemplate: formData.watemplate,
      });

      setSuccessMsg("Subscription template created successfully.");

      navigate('/dashboard/subscription');
    } catch (error) {
      setErrorMsg(error.message);
    } finally {
      setLoading(false);
    }
  };




  return (
    <div className="p-4">
      <button
        onClick={onBack}
        className="mb-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        ← Back
      </button>

      <h2 className="text-2xl font-semibold mb-4">Create Subscription Template</h2>

      {successMsg && <p className="text-green-600 mb-4">{successMsg}</p>}
      {errorMsg && <p className="text-red-600 mb-4">{errorMsg}</p>}

      <div className="space-y-4">
        <InputField label="Day" name="day" type="number" value={formData.day} onChange={handleChange} />
        <SelectField
          label="Time"
          name="time"
          value={formData.time}
          onChange={handleChange}
          options={[
            { id: "10:00:00", label: "10:00 AM" },
            { id: "13:00:00", label: "1:00 PM" },
            { id: "16:00:00", label: "4:00 PM" }
          ]}
          display={(t) => t.label}
        />

        {/* Anchor Dropdown */}
        <SelectField
          label="Anchor"
          name="anchor"
          value={formData.anchor}
          onChange={handleChange}
          options={anchors}
          display={(a) => `${a.name} (${a.code})`}
        />

        {/* WA Template Dropdown */}
        <SelectField
          label="WA Template"
          name="watemplate"
          value={formData.watemplate}
          onChange={handleChange}
          options={waTemplates}
          display={(t) => t.name}
        />

        {/* Subscription Dropdown */}
        <SelectField
          label="Subscription Plan"
          name="subscription"
          value={formData.subscription}
          onChange={handleChange}
          options={subscriptions}
          display={(s) => `${s.name} (${s.code})`}
        />

        <button
          onClick={handleSave}
          disabled={loading}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
          {loading ? "Saving..." : "Save Template"}
        </button>
      </div>
    </div>
  );
};

const InputField = ({ label, name, value, onChange, type = "text" }) => (
  <div>
    <label className="block font-medium mb-1">{label}:</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className="border rounded px-3 py-2 w-full"
    />
  </div>
);

const SelectField = ({ label, name, value, onChange, options, display }) => (
  <div>
    <label className="block font-medium mb-1">{label}:</label>
    <select
      name={name}
      value={value}
      onChange={onChange}
      className="border rounded px-3 py-2 w-full"
    >
      <option value="">Select {label}</option>
      {options.map((item) => (
        <option key={item.id} value={item.id}>
          {display(item)}
        </option>
      ))}
    </select>
  </div>
);

export default CreateSubTemplate;
